"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourgumReceivableSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const meta_data_invoice_1 = require("../base/meta-data-invoice");
exports.SourgumReceivableSchema = {
    name: 'sourgum-receivable',
    alias: 'Sourgum Receivable',
    shortName: 'Invoice',
    applications: ['aap', 'customer-portal'],
    disabled: false,
    returnType: {
        aap: transport_types_1.Invoice.ReceivableTransport,
        'customer-portal': transport_types_1.Invoice.CustomerReceivableTransport,
    },
    searchableAttributes: [
        {
            field: 'customerName',
            alias: 'Customer Name',
            shortName: 'Name',
            searchableByDefault: true,
        },
        {
            field: 'customerCompanyName',
            alias: 'Company',
            shortName: 'Company',
            searchableByDefault: true,
        },
        {
            field: 'customerAccountNumber',
            alias: 'Account Number',
            shortName: 'account_number',
            searchableByDefault: false,
        },
        {
            field: 'invoiceDetails.orderNumber',
            alias: 'Order Number',
            shortName: 'orderNumber',
            searchableByDefault: true,
        },
        {
            field: 'invoiceDetails.orderServiceLocation.address.addressLine1',
            alias: 'Address',
            shortName: 'Address',
            searchableByDefault: true,
        },
        {
            field: 'invoiceDetails.orderServiceLocation.address.addressLine2',
            alias: 'Service Location Address 2',
            searchableByDefault: false,
        },
        {
            field: 'invoiceDetails.orderServiceLocation.address.state',
            alias: 'Service Location State',
            shortName: 'State',
            searchableByDefault: false,
        },
        {
            field: 'invoiceDetails.orderServiceLocation.address.city',
            alias: 'Service Location City',
            shortName: 'City',
            searchableByDefault: true,
        },
        {
            field: 'invoiceDetails.orderServiceLocation.address.zip',
            alias: 'Service Location Zip Code',
            shortName: 'Zip',
            searchableByDefault: false,
        },
        {
            field: 'invoiceDetails.orderServiceLocation.county',
            alias: 'Service Location County',
            shortName: 'County',
            searchableByDefault: false,
        },
    ],
    filterableAttributes: [
        {
            type: 'STRING',
            field: 'invoiceDetails.status',
            alias: 'Invoice Status',
            shortName: 'Status',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            options: {
                aap: transport_types_1.Invoice.InvoiceStatuses.map((status) => ({
                    value: status,
                    label: transport_types_1.Invoice.InvoiceStatusLabels[status],
                })),
                'customer-portal': transport_types_1.Invoice.InvoiceStatuses.map((status) => ({
                    value: status,
                    label: transport_types_1.Invoice.InvoiceStatusLabels[status],
                })).filter((status) => status.value !== 'DRAFT'),
            },
        },
        {
            type: 'NUMBER',
            field: 'invoiceDetails.total',
            alias: 'Total',
            shortName: 'Amount',
            allowedOperators: 'ALL',
            format: 'MONEY',
        },
        {
            type: 'TIMESTAMP',
            field: 'invoiceDetails.refunds.date',
            alias: 'Refund Date',
            shortName: 'Refund Date',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
        {
            type: 'TIMESTAMP',
            field: 'invoiceDetails.payments.paymentReceivedDate',
            alias: 'Payment Date',
            shortName: 'Payment Date',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
        ...meta_data_invoice_1.MetaDataFiltersInvoice,
    ],
    extraMappings: [],
};
//# sourceMappingURL=sourgum-receivable.js.map